import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { useQuery } from '@tanstack/vue-query';

export const useCityToursInRegion = (regionSlug: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const { getCitiesToursByRegion } = useExperienceApi();

  const { data: cityToursInRegion } = useQuery({
    queryKey: ['getCitiesToursByRegion', regionSlug],
    queryFn: () => {
      return getCitiesToursByRegion({ path: { regionSlug: toValue(regionSlug) } });
    },
    enabled: computed(() => !!toValue(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    cityToursInRegion,
  };
};
